import React, { useEffect, useState } from 'react';
import Rimg from './Rimg.jsx';
import { useMediaQuery } from 'react-responsive';
import LazyVideo from './LazyVideo.jsx';


export default function CollectionHeader(props) {
  const isDesktop = useMediaQuery({ minWidth: 720 });
  const [image, setImage] = useState(props.image);

  useEffect(() => {
    if (isDesktop && props.mobile_image) {
      setImage(props.image);
    } else if (props.mobile_image) {
      setImage(props.mobile_image);
    }
  }, [isDesktop, props.image, props.mobile_image])
  let headerClassName = 'collection-title-header', collectionTitle = props.title, collectionDescription = props.description;
  if (props.hasSidebar) {
    headerClassName += ' sidebar-active';
  }
  if (props.title.includes('|')) {
    collectionTitle = props.title.split('|')[1]
  }
  if (props.metafields) {
    headerClassName += ` align-${props.metafields.alignment}`;
    if (props.metafields.invert_text) {
      headerClassName += ` invert-text`;
    }
    if (props.metafields.text) {
      collectionTitle = props.metafields.text;
    }
    if (props.metafields.description === 'swap') {
      collectionDescription = collectionTitle;
      collectionTitle = props.description;
    } else if (props.metafields.description === 'swap') {
      collectionDescription = null;
    }
  }
  if (!image.src) {
    return (null);
  }
  return (
    <header className={headerClassName}>
      {props.metafields.video ? 
        (<LazyVideo src={props.metafields.video} width={props.metafields.video_width} height={props.metafields.video_height} preload="auto" />) : 
        (<React.Fragment>
          <Rimg className="collection-image" alt={collectionTitle} src={image.src} width={image.width} height={image.height} loading="lazy" />
          <div data-rimg-canvas></div>
        </React.Fragment>)
      }
      
      <div className="collection-title page-title">
        <h1 className="label" dangerouslySetInnerHTML={{ __html: collectionTitle }} />
        <div className="rte description" dangerouslySetInnerHTML={{ __html: collectionDescription }} />
      </div>
    </header>
  )
}